import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters({
			currentRoute_: 'currentRoute',
		}),
		currentNotes() {
			return this.notes[this.part-1];
		},
	},
	watch: {
		currentRoute_(newName) {
			this.setPart(newName);
		},
	},
	data() {
		return {
			part: 1,
		};
	},
	mounted() {
		this.setPart(this.$route.name);
	},
	methods: {
		setPart(name) {
			const arr = name.split(";");
			if (arr.length > 1)
				this.part = parseInt(arr[1], 10);
			else
				this.part = 1;
		},
	},
};
